import PayMethodSelector from './components/pages/payMethodSelector';
import InvoiceCreation from './components/pages/invoiceCreation';
import PerformPayment from './components/pages/performPayment';
import InvoiceResult from './components/pages/invoiceResult';

const routes = [
  {
    name: 'payMethodSelector',
    path: '/pay',
    exact: true,
    component: PayMethodSelector,
  },
  {
    name: 'payment',
    path: '/pay/perform',
    exact: true,
    component: PerformPayment,
  },
  {
    name: 'invoiceResult',
    path: '/pay/result',
    exact: true,
    component: InvoiceResult,
  },
  {
    name: 'payWaySelector',
    path: '/pay/:payMethodId',
    exact: true,
    component: InvoiceCreation,
  },
];

export default routes;
